import { apiFetch } from './client';

export interface AppConfig {
  skipPhoneVerification: boolean;
  requireDocument: boolean;
  /** Experimental, desligado por padrão: janelas de disponibilidade em série. */
  recurringAvailability: boolean;
}

export const appConfigKeys = {
  all: ['app-config'] as const,
};

export function getAppConfig(): Promise<AppConfig> {
  return apiFetch<AppConfig>('/api/config');
}

export const appConfigQueryOptions = {
  queryKey: appConfigKeys.all,
  queryFn: getAppConfig,
  staleTime: 5 * 60 * 1000,
  retry: 1,
};
